import React, { useEffect, useRef, useState } from "react";
import "./Preloader.css";

import topBracket from "../../../assets/icons/bracet1.png";
import bottomBracket from "../../../assets/icons/bracet2.png";

const Preloader = ({
  loadedMedia = 0,
  totalMedia = 0,
  allMediaLoaded = false,
  onFinish,
}) => {
  const actualProgress =
    totalMedia > 0
      ? Math.min(100, Math.round((loadedMedia / totalMedia) * 100))
      : 100; // IMPORTANT: if nothing to load → instantly ready

  const [displayProgress, setDisplayProgress] = useState(0);
  const [isOpened, setIsOpened] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const finishCalledRef = useRef(false);

  // SMART PROGRESS (key improvement)
  useEffect(() => {
    let raf;

    const update = () => {
      setDisplayProgress((prev) => {
        let target = allMediaLoaded ? 100 : Math.min(actualProgress, 85);

        const next = prev + (target - prev) * 0.08;

        return next >= 99.5 ? 100 : next;
      });

      raf = requestAnimationFrame(update);
    };

    update();

    return () => cancelAnimationFrame(raf);
  }, [actualProgress, allMediaLoaded]);

  // open brackets
  useEffect(() => {
    const t = setTimeout(() => setIsOpened(true), 120);
    return () => clearTimeout(t);
  }, []);

  // finish flow
  useEffect(() => {
    if (!allMediaLoaded || displayProgress < 100) return;

    setIsClosing(true);

    setTimeout(() => {
      setIsExiting(true);
    }, 250);

    const timer = setTimeout(() => {
      if (finishCalledRef.current) return;
      finishCalledRef.current = true;
      onFinish && onFinish();
    }, 600);

    return () => clearTimeout(timer);
  }, [displayProgress, allMediaLoaded, onFinish]);

  return (
    <div className={`preloader ${isExiting ? "exit" : ""}`}>
      <div className="loader">

        <img
          src={topBracket}
          alt=""
          className={`bracket top ${isOpened ? "open" : ""} ${isClosing ? "close" : ""}`}
        />

        <div className={`percent ${isOpened && !isClosing ? "visible" : ""}`}>
          {Math.floor(displayProgress)}%
        </div>

        <img
          src={bottomBracket}
          alt=""
          className={`bracket bottom ${isOpened ? "open" : ""} ${isClosing ? "close" : ""}`}
        />

      </div>
    </div>
  );
};

export default Preloader;